import React from 'react'
import { Container, Paper, Typography } from '@material-ui/core'

function About() {
    return (
        <div>
            <Container maxWidth="md" style={{marginTop:'15px'}}>
                <Paper elevation={1} style={{width:'100%'}}>
                    <Typography variant="h5">About Paper Chat</Typography>


                    <div style={{textAlign:'left', margin: '20px'}}>


                        <div style={{margin:'15px 15px'}}>
                            <Typography variant="h6" style={{fontWeight:'bold'}}>The General Idea</Typography>
                            <Typography variant="body2">
                                The purpose of the Paper Chat is to allow you to chat with other people without needing anything more than a web browser to do it.
                                <br></br><br></br>
                                For using Paper Chat you dont need to register or something. No authentication required.
                                <br></br><br></br>
                                The idea is you turn up, create a room name (and with a password, if you like), you tell other people the room name (and password), and you start chatting away.
                                <br></br><br></br>
                                The service is free, and is designed to be as simple as possible to use, either for short, two person, five line conversations, or for longer ten person, thousand line conversations.
                            </Typography>
                        </div>

                        <div style={{margin:'15px 15px'}}>
                            <Typography variant="h6" style={{fontWeight:'bold'}}>Who am I?</Typography>
                            <Typography variant="body2">
                            Basically, I am CS Student who is sufficiently anti-social that I spend spare time coding. 
                            I decided to create the site as an interesting exercise to keep us occupied outside of work.
                                <br></br><br></br>
                                I am not developing Paper Chat for a living — I have other jobs for that. 
                                But I find it entertaining to work on as a side project.

                                <br></br><br></br>
                                If you want to contact me, you can reach me at <a href="mailto:sidsaini1196@gmail.com">sidsaini1196@gmail.com</a>
                            </Typography>
                        </div>


                        <div style={{margin:'15px 15px'}}>
                            <Typography variant="h6" style={{fontWeight:'bold'}}>Disclaimer</Typography>
                            <Typography variant="body2">
                            Why should you care about who am I? You shouldn't. Surely you have better things to do with your time! 
                            But I suppose the implications of the above could be relevant to some people.
                                <br></br><br></br>
                                I don't see any reason that the site should crash frequently or go away,
                                 but I don't promise you that it won't, and I won't be held responsible if and when it breaks.

                                <br></br>
                                <i>Please do not use it in nuclear reactors.</i>
                            </Typography>
                        </div>

                        <div style={{margin:'15px 15px'}}>
                            <Typography variant="h6" style={{fontWeight:'bold'}}>Feature requests</Typography>
                            <Typography variant="body2">
                                If you've got some ideas that you think might be of interest, then feel free to let me know.
                                <br></br>  
                            </Typography>
                        </div>


                        <div style={{margin:'15px 15px'}}>
                            <Typography variant="h6" style={{fontWeight:'bold'}}>FAQ</Typography>
                            <div style={{margin:'10px'}}>
                                <Typography variant="subtitle1" style={{fontWeight:'bold'}}>How secure are the passwords?</Typography>
                                <Typography variant="body2" style={{margin:'5px 15px'}}>
                                    Not secure at all. 
                                    Basically, the idea of using room passwords is just so that people can't guess a 
                                    room name and turn up in the middle of your conversation. 
                                    They're not used to encrypt anything (your chat messages are still sent to us in plain text, 
                                    and stored in memory that way too).
                                    <br></br><br></br>
                                    <strong>Do not use any of your regular passwords as the password for a room on this site! If you do, 
                                        don't blame us when other people discover your password!</strong>
                                </Typography>
                            </div>

                            <div style={{margin:'10px'}}>
                                <Typography variant="subtitle1" style={{fontWeight:'bold'}}>Do you make any money off this?</Typography>
                                <Typography variant="body2" style={{margin:'5px 15px'}}>
                                Not at the moment, no. <br></br>
                                If you found anyway let me know. 
                              
                                </Typography>
                            </div>

                            <div style={{margin:'10px'}}>
                                <Typography variant="subtitle1" style={{fontWeight:'bold'}}>What's the portal written in?</Typography>
                                <Typography variant="body2" style={{margin:'5px 15px'}}>
                                   Serveless Framework with Firebase realtime Datebase for Backend and React JS with Matrial UI for Front End.
                                </Typography>
                            </div>

                            <div style={{margin:'10px'}}>
                                <Typography variant="subtitle1" style={{fontWeight:'bold'}}>Can you read our chats?</Typography>
                                <Typography variant="body2" style={{margin:'5px 15px'}}>
                                    In theory, yes. I haven't implemented any encryption, so yes, I could read your chats. I don't see any point in doing that, though, and also, anything you say is forgotten once it's no longer needed. I delete entire rooms after 2 
                                    minutes after the last person leaves, and if there are more than 100 chat messages in a room, I'll forget all but that many messages (although I'll make sure to keep at least the last 30 seconds worth, for those who type real fast!).
                                        <br></br><br></br>
                                        I don't think you should be worried. I am not planning on reading any of your chats.
                                </Typography>
                            </div>

                            <div style={{margin:'34px 15px'}}>
                                <Typography>
                                    No Copyright isuue. Feel free to use anything you find useful in it.
                                    <br></br>
                                    <br></br>
                                </Typography>
                            </div>
                        </div>
                    </div>

                </Paper>
            </Container>
        </div>
    )
}

export default About
